<template>
	<div class="questionTaskRecord">
		<div class="questionTaskRecord_mask" v-if="baseInfo.status === 3"></div>
		<van-notice-bar mode="closeable" background="#333333" color="#ffffff">{{
			baseInfo.title
		}}</van-notice-bar>
		<div class="questionTaskRecord_title">导师任务说明：</div>
		<div class="questionTaskRecord_topic">
			<div class="questionTaskRecord_topic_word">
				正文内容：
				<br />
				{{ baseInfo.description }}
				<br />
				<br />
				<div class="questionTaskRecord_topic_attachment">
					附件下载：
					<div
						@click="
							() =>
								handleDownloadUrl(item.id, item.name, 'teacher')
						"
						:href="item.url"
						v-for="(item, index) in baseInfo.bookAttachments"
						:key="index"
						style="margin-right:.12rem"
					>
						{{ item.name }}
					</div>
				</div>
			</div>
		</div>
		<template>
			<div class="questionTaskRecord_title">提交的任务：</div>
			<div class="questionTaskRecord_reply">
				<div class="questionTaskRecord_reply_word">
					<van-field
						v-model="attachmentComment"
						placeholder="请填写"
						rows="5"
						autosize
						type="textarea"
						:disabled="computedStudent(roleName, baseInfo.status)"
					/>
				</div>
			</div>
		</template>
		<div class="questionTaskRecord_title">附件：</div>
		<!-- 上传 -->
		<div class="questionTaskRecord_uploads">
			<van-uploader
				:preview-image="false"
				:max-count="6"
				:after-read="uploadImage"
				:preview-full-image="false"
				:accept="accept"
				@oversize="oversize"
				v-if="baseInfo.status <= 1 && fileList.length <= 6"
			>
				<van-button
					icon="plus"
					color="#3F9EFF"
					type="primary"
					size="small"
					style="margin:.1rem 0"
					>上传文件</van-button
				>
			</van-uploader>
			<div style="font-size:12px;color:#999;margin-top:8px">
				支持：{{ accept }}，文件大小应小于200MB。
			</div>
			<!-- 展示 -->
			<div
				class="questionTaskRecord_uploads_list"
				v-if="baseInfo.status <= 1"
			>
				<div
					class="questionTaskRecord_uploads_item"
					v-for="(item, index) in fileList"
					:key="index"
				>
					{{ item.name }}
					<van-icon
						name="clear"
						size=".18rem"
						color="#c32929"
						@click="() => handleRemove(index)"
					/>
				</div>
			</div>
			<div class="questionTaskRecord_uploads_list" v-else>
				<div
					@click="
						() => handleDownloadUrl(item.id, item.name, 'student')
					"
					:href="item.attachmentAddress"
					class="questionTaskRecord_uploads_item"
					v-for="(item, index) in baseInfo.attachments"
					:key="index"
				>
					{{ item.name }}
				</div>
			</div>
		</div>
		<!-- <template
			v-if="
				baseInfo.status > 1 ||
					(roleName === 'teacher' && baseInfo.status > 0)
			"
		>
			<div class="questionTaskRecord_title">
				导师评语及打分：

				<van-field
					input-align="center"
					type="digit"
					v-model="score"
					class="questionTaskRecord_title_input"
					placeholder="请打分"
					:disabled="computedTeacher(roleName, baseInfo.status)"
				>
				</van-field>
				分
			</div>
			<div class="questionTaskRecord_topic">
				<div class="questionTaskRecord_topic_word" style="padding:0px">
					<van-field
						v-model="comment"
						placeholder="请填写您补充的任务说明"
						rows="5"
						autosize
						type="textarea"
						:disabled="computedTeacher(roleName, baseInfo.status)"
					/>
				</div>
			</div>
		</template> -->
		<div
			class="questionTaskRecord_btns"
			v-if="computedShowBtn(baseInfo.status)"
		>
			<div class="questionTaskRecord_btns_cancel" @click="handleBack">
				取消
			</div>
			<div
				class="questionTaskRecord_btns_confirm"
				@click="() => handleSubmit()"
			>
				提交
			</div>
		</div>
	</div>
</template>

<script>
import { parseName, checkRole, downloadUrl } from "@/common/utils.js";
import { NoticeBar, Field, Uploader, Button, Toast, Icon } from "vant";

export default {
	computed: {
		computedParseName() {
			return function(value) {
				return parseName(value);
			};
		},
		computedStudent() {
			return function(roleName, status) {
				let readOnly = this.readOnly;
				if (readOnly) {
					return true;
				}
				if (status > 1) {
					return true;
				} else {
					return false;
				}
			};
		},
		computedTeacher() {
			return function(roleName, status) {
				let readOnly = this.readOnly;
				if (readOnly) {
					return true;
				}
				if (roleName === "student" || status > 1) {
					return true;
				} else {
					return false;
				}
			};
		},
		computedShowBtn() {
			return function(value) {
				let roleName = this.roleName;
				let readOnly = this.readOnly;
				if (readOnly) {
					return false;
				}
				switch (value) {
					case 0:
						return true;
					case 1:
						return true;
					case 2:
						return false;
					case 3:
						return false;
				}
			};
		}
	},
	components: {
		[Button.name]: Button,
		[Icon.name]: Icon,
		[NoticeBar.name]: NoticeBar,
		[Field.name]: Field,
		[Uploader.name]: Uploader
	},
	data() {
		return {
			accept:
				".jpg,.jpeg,.png,.gif,.mp4,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx",
			readOnly: false,
			fileList: [],
			attachmentComment: "",
			comment: "",
			score: "",
			baseInfo: {},
			roleName: ""
		};
	},
	mounted() {
		this.fetchData();
	},
	methods: {
		handleDownloadUrl(id, name, role) {
			let path = `/v1.0/downloads/downloadAttach/${role}/${id}`;
			downloadUrl(path, name);
		},
		handleBack() {
			history.back(-1);
		},
		async handleRemove(index) {
			let fileList = this.fileList;
			let { code } = await this.h5Ajax(
				"get",
				`$/distribute/removeAttachment/${fileList[index].id}`,
				{},
				true,
				true
			);
			if (code === 200) {
				this.fileList.splice(index, 1);
			}
		},
		async handleSubmit() {
			let { id } = this.$route.query;
			// let baseInfo = this.baseInfo;
			// if (baseInfo.status === 0) {
			if (!this.attachmentComment) {
				return Toast("内容不得为空");
			}
			let { code } = await this.h5Ajax(
				"post",
				"$/distribute/distributeSubmit",
				{
					id: id,
					attachmentComment: this.attachmentComment
				},
				true,
				true
			);
			if (code === 200) {
				Toast({
					message: "提交成功",
					forbidClick: true,
					onClose: () => {
						this.handleBack();
					}
				});
			}
			// } else if (baseInfo.status === 1) {
			// 	if (form.comment && form.score >= 0) {
			// 		let { code } = await this.h5Ajax(
			// 			"post",
			// 			"$/distribute/distributeScore",
			// 			{
			// 				id: id,
			// 				comment: this.comment,
			// 				score: this.score
			// 			},
			// 			true,
			// 			true
			// 		);
			// 		if (code === 200) {
			// 			Toast({
			// 				message: "提交成功",
			// 				forbidClick: true,
			// 				onClose: () => {
			// 					this.handleBack();
			// 				}
			// 			});
			// 		}
			// 	}
			// } else {
			// 	return Toast("内容不得为空");
			// }
		},
		async fetchData() {
			let { id } = this.$route.query;
			let { code, data } = await this.h5Ajax(
				"get",
				`$/distribute/detail/${id}`,
				{},
				true,
				true
			);
			if (code === 200) {
				let attachments = data.attachments;
				attachments.forEach(item => {
					item.name = item.name || item.attachmentName;
				});

				this.baseInfo = {
					...data.jobBook,
					status: data.status,
					bookId: data.bookId,
					userId: data.uid,
					id: data.id,
					attachmentComment: data.attachmentComment,
					attachments: data.attachments,
					score: data.score,
					comment: data.comment
				};

				data.attachmentComment &&
					(this.attachmentComment = data.attachmentComment);
				data.comment && (this.comment = data.comment);
				data.score && (this.score = data.score);
				data.attachments && (this.fileList = attachments);
				this.roleName = checkRole(data.userId);
			}
		},
		oversize(e) {
			let size = e.file.size;
			if (size >= 4 * 1024 * 1024) {
				Toast("图片尺寸太大");
			}
		},
		// 上传
		async uploadImage({ file }) {
			let baseInfo = this.baseInfo;
			let params = {
				bookId: baseInfo.bookId,
				userId: baseInfo.userId
			};
			this.h5AjaxUpload(file, "$/upload/studentFileUpload", params)
				.then(res => {
					if (res) {
						let fileList = this.fileList;
						fileList.push(res);
						this.fileList = fileList;
					} else {
						Toast("上传失败，请重试！");
					}
				})
				.catch(err => {
					console.error("err:" + err);
					Toast("catch：上传失败，请重试！");
				});
		}
	}
};
</script>

<style>
@import "./index.css";
</style>



// WEBPACK FOOTER //
// src/app/pages/question/task/record/index.vue